import React from "react";
import {
  Search,
  Users,
  Box,
  FileText,
  Video,
  BadgeCheck,
} from "lucide-react";

const steps = [
  {
    number: "01",
    icon: Search,
    title: "Find an Expert",
    desc: "Search by industry, technology, skill, experience, consultation type.",
  },
  {
    number: "02",
    icon: Users,
    title: "View Profile",
    desc: "Experience, qualifications, expertise, projects, ratings, fees.",
  },
  {
    number: "03",
    icon: Box,
    title: "Select Consultation",
    desc: "30-min call, CAD review, manufacturing consult, advisory.",
  },
  {
    number: "04",
    icon: FileText,
    title: "Share Requirement",
    desc: "Upload CAD, drawings, images, videos, technical docs.",
  },
  {
    number: "05",
    icon: Video,
    title: "Consult",
    desc: "Video, audio, chat, document review or technical discussion.",
  },
  {
    number: "06",
    icon: BadgeCheck,
    title: "Receive Recommendations",
    desc: "Design, process, material, prototype roadmap and report.",
  },
];

export default function HowItWorks() {
  return (
    <section className="w-full bg-[#0a0f1e]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        {/* Eyebrow */}
        <p className="text-[11px] sm:text-xs tracking-[0.2em] font-semibold text-amber-400 uppercase mb-5">
          How It Works
        </p>

        {/* Headline */}
        <h2 className="font-serif text-white leading-[1.1] text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] max-w-3xl">
          From question to prototype &mdash; with{" "}
          <span className="text-amber-400">expert guidance.</span>
        </h2>

        {/* Grid */}
        <div className="mt-12 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {steps.map(({ number, icon: Icon, title, desc }) => (
            <div
              key={number}
              className="rounded-2xl border border-white/10 bg-[#0d1526] p-6 sm:p-7 hover:border-white/20 transition-colors duration-200"
            >
              <div className="flex items-start justify-between mb-8 sm:mb-10">
                <span className="font-serif text-amber-400/90 text-3xl sm:text-4xl">
                  {number}
                </span>
                <Icon
                  className="w-5 h-5 text-amber-400"
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="font-semibold text-white text-lg sm:text-xl mb-2">
                {title}
              </h3>
              <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}